<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 20px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="消息模板代码">
                <a-input v-model="query.templateCode" placeholder="请输消息模板代码！" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="状态">
                <a-select placeholder="请选择状态" v-model="query.status" allow-clear>
                  <a-select-option value="0"> 启用 </a-select-option>
                  <a-select-option value="1"> 不启用 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="消息模板名称">
                <a-input v-model="query.templateName" placeholder="请输入消息模板名称！" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del>删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :data-source="list"
        :pagination="pagination"
        @change="pageChange"
        bordered
      >
        <span slot="status" slot-scope="text">
          <span v-if="text == 0"> 启用 </span>
          <span v-else> 不启用 </span>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="Handle(record.id)" v-action:edit>编辑</a>
        </span>
      </a-table>
      <a-modal title="消息模板" width="50%" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
        <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="消息模板代码">
            <a-input v-decorator="['templateCode', { rules: [{ required: true, message: '请输入消息模板代码!' }] }]" />
          </a-form-item>
          <a-form-item label="消息模板名称">
            <a-input v-decorator="['templateName', { rules: [{ required: true, message: '请输入消息模板名称!' }] }]" />
          </a-form-item>
          <a-form-item label="消息模板标题">
            <a-input v-decorator="['headline', { rules: [{ required: true, message: '请输入消息模板标题!' }] }]" />
          </a-form-item>
          <a-form-item label="模板内容">
            <a-textarea v-decorator="['templateBody', { rules: [{ required: true, message: '请输入模板内容!' }] }]"  :rows="4" />
          </a-form-item>
          <a-form-item label="状态">
            <a-radio-group
              v-decorator="['status', { initialValue: 0, rules: [{ required: true }] }]"
              style="width: 80%"
            >
              <a-radio :value="0">启用</a-radio>
              <a-radio :value="1">不启用</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      currentId: '',
      isUpdate: false,
      visibles: false,
      equipmentList: [],
      parameterList: [],
      queryUrl: '/pipe-network/api/v1/sms/templates/page',
      addOrUpdateUrl: '/pipe-network/api/v1/sms/templates',
      deleteUrl: '/pipe-network/api/v1/sms/templates', // 删除数据url
      queryZoneDateUrl: 'zone-metering/zone-metering',
      queryOneUrl: '/pipe-network/api/v1/sms/templates/',
      confirmLoading: false,
      fetching: false,
      fetchingk: false,
      list: [],
      zoneTreeData: [], // 分区数据选项
      typelists: [],
      query: {
        templateCode: '',
        status: '',
        templateName: '',
      },
      valueDTOList: [
        {
          interworkingValveIds: [],
          mainValveIds: [],
          flag: true,
        },
      ],
      naturclicks: 1,
      columns: [
        {
          title: '消息模板代码',
          dataIndex: 'templateCode',
        },
        {
          title: '模板标题',
          dataIndex: 'headline',
          ellipsis: true,
        },
        {
          title: '模板名称',
          dataIndex: 'templateName',
          scopedSlots: { customRender: '' },
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },
  mounted() {
    this.queryList()
  },
  created() {
    this.resetList()
    this.queryList()
  },
  methods: {
    deleteArr(index) {
      this.valueDTOList.splice(index, 1)
    },
    handleChange(e) {},
    Handle(e) {
      this.addOrUpdateHandle(e)
      this.resetList()
    },
    //取消
    handleCancel(e) {
      console.log('Clicked cancel button')
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
/deep/ .ant-table-thead > tr > th > {
  text-align: center;
}

/deep/ .ant-table-tbody > tr > td {
  text-align: center;
}
</style>